import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { agentOfficeSetupService } from "services";
import { uiActions } from "store";
import { ChangeFeeTemplateDefaultProps, ErrorResponse } from "types";

const useUpdateFeeTemplateDefaultMutation = (onSuccess?: Function) => {
	const dispatch = useDispatch();

	return useMutation(
		({
			companyId,
			templateId,
			isDefault,
		}: ChangeFeeTemplateDefaultProps) => {
			dispatch(uiActions.showSpinnerOverlay());
			return agentOfficeSetupService.changeFeeTemplateDefault({
				companyId,
				templateId,
				isDefault,
			});
		},
		{
			onSuccess() {
				onSuccess?.();
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
			onSettled() {
				dispatch(uiActions.hideSpinnerOverlay());
			},
		},
	);
};

export default useUpdateFeeTemplateDefaultMutation;
